import Dashboard from "../Views/Dashboard";
import { connect } from "react-redux";
import { spendBudget, recivBudget, getFs, modifyFs, specRecivBud} from "../Actions/Finance_actions";
 
const mapStateToProps = ({Fs, Indicate}) => ({
    loading: Indicate,
    budg: Fs.map(list => list.budg),
    allFs: Fs.length >= 1 ? Fs : '',
})

const mapDispatchToProps = dispatch => {
    
    return {
        
    moneySpent: ({budg, amt, purpose}) => dispatch(spendBudget({budg: budg, amt: amt, purpose: purpose})),

    moneyReciv: ({purpose, amt}) => dispatch(recivBudget({purpose: purpose, amt: amt })),

    getDataFromMongo: () =>  dispatch( getFs() ),
    
    sendNewDataToMongo: (arr) =>  modifyFs(arr),

    moneyRecivSpec: ({purpose, budg, amt}) => dispatch(specRecivBud({purpose:purpose , budg:budg, amt:amt}))

     }
}
 
  
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);